// extracted by mini-css-extract-plugin
module.exports = {"factButton":"FactButton_factButton__1KVCE","buttonError":"FactButton_buttonError__3n2wG","buttonErrorAnimation":"FactButton_buttonErrorAnimation__3M6W_"};